import React from "react";
import SpinnerIcon from "src/assets/spinner.svg?react";

interface LoadingOverlayProps {
  isLoading: boolean;
  classNames?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isLoading,
  classNames = "",
}) => {
  if (!isLoading) return null;

  return (
    <div
      className={`z-50 flex h-full w-full flex-1 items-center justify-center bg-gray1 dark:bg-black2 ${classNames}`}
    >
      <SpinnerIcon className="h-16 w-16" />
    </div>
  );
};

export default LoadingOverlay;
